import { REQ_DATA as types } from '@store/constants';

export const updateUsersReqData = (reqData) => ({
  type: types.UPDATE_USERS_REQ_DATA,
  payload: reqData
});

export const updateLuluOrdersReqData = (reqData) => ({
  type: types.UPDATE_LULU_ORDERS_REQ_DATA,
  payload: reqData
});

export const updateOrdersReqData = (reqData) => ({
  type: types.UPDATE_ORDERS_REQ_DATA,
  payload: reqData
});

export const updateGomsOrdersReqData = (reqData) => ({
  type: types.UPDATE_GOMS_ORDERS_REQ_DATA,
  payload: reqData
});

export const updateActiveSearch = (search) => ({
  type: types.UPDATE_ACTIVE_SEARCH,
  payload: search
});

export const updateActiveLuluOrdersTab = (tab) => ({
  type: types.UPDATE_ACTIVE_LULU_ORDERS_TAB,
  payload: tab
});

export const updateActiveKycFunnel = (funnel) => ({
  type: types.UPDATE_ACTIVE_KYC_USERS_FUNNEL,
  payload: funnel
});

export const updateLuluFunnelOrdersReqData = ({ tab, pageNo }) => ({
  type: types.UPDATE_LULU_FUNNEL_ORDERS_REQ_DATA,
  payload: {
    tab,
    reqData: {
      pageNo
    }
  }
});

export const updateFunnelKycUsersReqData = ({ status, pageNo }) => ({
  type: types.UPDATE_FUNNEL_USERS_REQ_DATA,
  payload: {
    status,
    reqData: {
      pageNo
    }
  }
});

export const updateCampaignsReqData = (reqData) => ({
  type: types.UPDATE_CAMPAIGNS_REQ_DATA,
  payload: reqData
});

export const updateNrUsersReqData = (reqData) => ({
  type: types.UPDATE_NR_USERS_REQ_DATA,
  payload: reqData
});

export const updateProviderHolidaysReqData = (reqData) => ({
  type: types.UPDATE_PROVIDER_HOLIDAYS_REQ_DATA,
  payload: reqData
});

export const updateKycChecksReqData = (reqData) => ({
  type: types.UPDATE_KYC_CHECKS_REQ_DATA,
  payload: reqData
});

export const updateKycsReqData = (reqData) => ({
  type: types.UPDATE_ALL_KYCS_REQ_DATA,
  payload: reqData
});

export const updateUserKycTiersReqData = (reqData) => ({
  type: types.UPDATE_USER_KYC_TIERS_REQ_DATA,
  payload: reqData
});

export const updateUserRemittanceOrdersReqData = (reqData) => ({
  type: types.UPDATE_USER_TRANSFERS_REQ_DATA,
  payload: reqData
});

export const updateUserBBPSOrdersReqData = (reqData) => ({
  type: types.UPDATE_USER_BBPS_ORDERS_REQ_DATA,
  payload: reqData
});

export const updateBBPSComplaintsReqData = (reqData) => ({
  type: types.UPDATE_BBPS_COMPLAINTS_REQ_DATA,
  payload: reqData
});

export const updateUserReferralReqData = (reqData) => ({
  type: types.UPDATE_USER_REFERRAL_REQ_DATA,
  payload: reqData
});

export const updateUserSipsReqData = (reqData) => ({
  type: types.UPDATE_USER_SIPS_REQ_DATA,
  payload: reqData
});

export const updateThunesReqData = (reqData) => ({
  type: types.UPDATE_THUNES_ORDERS_REQ_DATA,
  payload: reqData
});

export const updateThunesFulfillmentsReqData = (reqData) => ({
  type: types.UPDATE_THUNES_FULFILLMENTS_REQ_DATA,
  payload: reqData
});

export const updateSourceAccountReqData = (reqData) => ({
  type: types.UPDATE_SOURCE_ACCOUNTS_REQ_DATA,
  payload: reqData
});

export const updateJobsReqData = (reqData) => ({
  type: types.UPDATE_JOBS_REQ_DATA,
  payload: reqData
});

export const updateRedeemedCoinsReqData = (reqData) => ({
  type: types.UPDATE_REDEEMED_COINS_REQ_DATA,
  payload: reqData
});

export const updateUserRedeemedCoinsReqData = (reqData) => ({
  type: types.UPDATE_USER_REDEEMED_COINS_REQ_DATA,
  payload: reqData
});

export const updateFunnelV2ReqData = (reqData) => ({
  type: types.UPDATE_FUNNEL_V2_REQ_DATA,
  payload: reqData
});

export const updateFunnelV2OrdersReqData = (status, reqData) => ({
  type: types.UPDATE_FUNNEL_V2_ORDERS_REQ_DATA,
  payload: {
    status,
    reqData
  }
});

export const updateGomsFunnelReqData = (reqData) => ({
  type: types.UPDATE_GOMS_FUNNEL_REQ_DATA,
  payload: reqData
});

export const updateGomsFunnelOrdersReqData = (status, reqData) => ({
  type: types.UPDATE_GOMS_FUNNEL_ORDERS_REQ_DATA,
  payload: {
    status,
    reqData
  }
});

export const updateTicketsReqData = (reqData) => ({
  type: types.UPDATE_TICKETS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateNrobReqData = (reqData) => ({
  type: types.UPDATE_NROB_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateUserSourceAccountsReqData = (reqData) => ({
  type: types.UPDATE_USER_SOURCE_ACCOUNTS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateRdaReqData = (reqData) => ({
  type: types.UPDATE_RDA_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateVanceCashReqData = (reqData) => ({
  type: types.UPDATE_VANCE_CASH_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateVdaFunnelReqData = (reqData) => ({
  type: types.UPDATE_VDA_FUNNEL_REQ_DATA,
  payload: {
    ...reqData
  }
});


export const updatePendingOrderReceiptsReqData = (reqData) => ({
  type: types.UPDATE_PENDING_ORDER_RECEIPTS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateRewardsReqData = (reqData) => ({
  type: types.UPDATE_REWARDS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateBaerscrestOpsReqData = (reqData) => ({
  type: types.UPDATE_BAERSCREST_OPS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateRdaDashboardReqData = (reqData) => ({
  type: types.UPDATE_RDA_DASHBOARD_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateFalconClientReqData = (reqData) => ({
  type: types.UPDATE_FALCON_CLIENT_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateFalconTransactionsReqData = (reqData) => {
  return {
    type: types.UPDATE_FALCON_TRANSACTIONS_REQ_DATA,
    payload: {
      ...reqData
    }
  };
};

export const updateFalconVendorReqData = (reqData) => ({
  type: types.UPDATE_FALCON_VENDOR_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateFalconRFITransactionsReqData = (reqData) => ({
  type: types.UPDATE_FALCON_RFI_TRANSACTIONS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateBeneficiaryDashboardReqData = (reqData) => ({
  type: types.UPDATE_BENEFICIARY_VERIFICATION_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateLuluRefundDashboardReqData = (reqData) => ({
  type: types.UPDATE_LULU_ORDER_REFUND_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateReconDepositDashboardReqData = (reqData) => ({
  type: types.UPDATE_RECON_DEPOSIT_REQ_DATA,
  payload: {
    ...reqData
  }
})

export const updateFalconAnalyticsReqData = (reqData) => ({
  type: types.UPDATE_FALCON_ANALYTICS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateGlobalSettlementTimelineReqData = (reqData) => ({
  type: types.UPDATE_GLOBAL_SETTLEMENT_TIMELINE_REQ_DATA,
  payload: {
   ...reqData
  }
});

export const updateRfiSettlementTimelineReqData = (reqData) => ({
  type: types.UPDATE_RFI_SETTLEMENT_TIMELINE_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateFulfillmentSettlementTimelineReqData = (reqData) => ({
  type: types.UPDATE_FULFILLMENT_SETTLEMENT_TIMELINE_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updatePaymentSettlementTimelineReqData = (reqData) => ({
  type: types.UPDATE_PAYMENT_SETTLEMENT_TIMELINE_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateWorkflowDocsReqData = (reqData) => ({
  type: types.UPDATE_WORKFLOW_DOCS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateSettlementServiceClientsReqData = (reqData) => ({
  type: types.UPDATE_SETTLEMENT_SERVICE_CLIENTS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateSettlementServiceLedgersReqData = (reqData) => ({
  type: types.UPDATE_SETTLEMENT_SERVICE_LEDGERS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateSettlementServiceAccountsReqData = (reqData) => ({
  type: types.UPDATE_SETTLEMENT_SERVICE_ACCOUNTS_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateSardineOnHoldReqData = (reqData) => ({
  type: types.UPDATE_SARDINE_ON_HOLD_REQ_DATA,
  payload: {
    ...reqData
  }
});

export const updateGomsOnHoldFulfillmentsReqData = (reqData) => ({
  type: types.UPDATE_GOMS_FULFILLMENT_REQ_DATA,
  payload: reqData
});

export const updateFalconFraudCaseManagerReqData = (reqData) => ({
  type: types.UPDATE_FALCON_FRAUD_CASE_MANAGER_REQ_DATA,
  payload: reqData
});

export const updateFalconCaseInvestigationManagerReqData = (reqData) => ({
  type: types.UPDATE_FALCON_CASE_INVESTIGATION_MANAGER_REQ_DATA,
  payload: reqData
});

export const updateOutboundCallingTicketsReqData = (reqData) => ({
  type: types.UPDATE_OUTBOUND_CALLING_TICKETS_REQ_DATA,
  payload: reqData
});

// Libra Dashboard actions
export const updateLibraAccountsReqData = (reqData) => ({
  type: types.UPDATE_LIBRA_ACCOUNTS_REQ_DATA,
  payload: reqData
});

export const updateLibraTransfersReqData = (reqData) => ({
  type: types.UPDATE_LIBRA_TRANSFERS_REQ_DATA,
  payload: reqData
});

export const updateLibraCorporateBeneficiariesReqData = (reqData) => ({
  type: types.UPDATE_LIBRA_CORPORATE_BENEFICIARIES_REQ_DATA,
  payload: reqData
});

export const updateLibraScheduledTransfersReqData = (reqData) => ({
  type: types.UPDATE_LIBRA_SCHEDULED_TRANSFERS_REQ_DATA,
  payload: reqData
});

// Fast Transfer Manager actions
export const updateFastTransferManagerReqData = (reqData) => ({
  type: types.UPDATE_FAST_TRANSFER_MANAGER_REQ_DATA,
  payload: {
    ...reqData
  }
});
